import { getRandomId } from 'core/utils/getRandomId';
import { AnalysisRequirementInputWithExtras } from '../types/AnalysisRequirementInputWithExtras';

export const defaultNewRequirement = (
  override?: Partial<AnalysisRequirementInputWithExtras>
): AnalysisRequirementInputWithExtras => ({
  content: '',
  isMandatory: false,
  isRecommendationDismissed: false,
  weight: 1,
  key: getRandomId(),
  ...override
});
